// observatorio_react\src\paginas-de-teste\Graficos\Grafico05\index.js

import nordeste from "../../../../../utils/geojsons/nd-geojson.json";

import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

let mobile = window.innerWidth <= 768;

export function MapaNordesteChart({ dados, style }) {
  echarts.registerMap("nordeste", nordeste);

  const option = {
    tooltip: {
      trigger: "item",
      showDelay: 0,
      transitionDuration: 0.2,
      formatter: (params) => {
        return (
          params.data?.name +
          "<br/> quantd.: <strong>" +
          params.data?.qtd +
          "</strong>"
        );
      },
    },

    dataset: {
      source: dados.map((item) => {
        return { name: item.name, value: item.value, qtd: item.qtd };
      }),
    },

    visualMap: {
      show: true,
      type: "continuous",
      inRange: {
        color: ["#e5d3bd", "#fabb54", "#3b2c14"],
      },

      precision: 50,
      dimension: "value",
      min: 4.1,
      max: 49,
      text: ["49%", "4.1%"],

      formatter: function (value) {
        return value.toFixed(1) + "%";
      },
    },

    series: {
      name: "Porcent. de profissionais",
      nameProperty: "uf",
      colorBy: "data",
      label: {
        show: true,
        position: "inside",
        fontSize: mobile ? 9 : 12,
        formatter: "{@value}% ({@name})",
        fontWeight: "bold",
        //backgroundColor: "#fff",
        height: 12,

        color: "inherit",
      },

      itemStyle: {
        borderColor: "#eee",
        borderWidth: 1,
      },

      select: {
        itemStyle: {
          areaColor: "#90CBF0",
        },
      },

      emphasis: {
        label: {
          color: "#000",
        },
        itemStyle: {
          areaColor: "#90CBF0",
        },
      },

      type: "map",
      map: "nordeste",
      dimensions: ["name", "value", "qtd"],
      geoIndex: 0,
      aspectScale: 1,
      zoom: 1.2,
      zlevel: 3,
    },
  };

  return <ReactECharts option={option} style={style} />;
}
